import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { clearMessage } from '../../store/actions/action';

const AUTO_DISMISS_MS = 4800;

const CONFIG = {
    success: {
        svg: (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
            </svg>
        ),
        label: 'Success',
        colorClass: 'nt--success',
    },
    error: {
        svg: (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
        ),
        label: 'Error',
        colorClass: 'nt--error',
    },
    warning: {
        svg: (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
        ),
        label: 'Warning',
        colorClass: 'nt--warning',
    },
    info: {
        svg: (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
        ),
        label: 'Info',
        colorClass: 'nt--info',
    },
};

function Toast({ message, type = 'success' }) {
    const dispatch = useDispatch();
    const [phase, setPhase] = useState('entering'); // entering | visible | leaving

    const dismiss = useCallback(() => {
        setPhase('leaving');
        setTimeout(() => dispatch(clearMessage()), 420);
    }, [dispatch]);

    useEffect(() => {
        setPhase('entering');
        const showTimer  = setTimeout(() => setPhase('visible'), 20);
        const hideTimer  = setTimeout(dismiss, AUTO_DISMISS_MS);
        return () => { clearTimeout(showTimer); clearTimeout(hideTimer); };
    }, [message, dismiss]);

    const { svg, label, colorClass } = CONFIG[type] || CONFIG.success;

    return (
        <div
            className={`nt-card ${colorClass} nt-phase-${phase}`}
            role="alert"
            aria-live="polite"
        >
            <div className="nt-card__accent" />

            <div className="nt-card__icon">{svg}</div>

            <div className="nt-card__body">
                <p className="nt-card__label">{label}</p>
                <p className="nt-card__msg">{message}</p>
            </div>

            <button className="nt-card__close" onClick={dismiss} aria-label="Close notification">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </button>

            <div className="nt-card__bar" style={{ animationDuration: `${AUTO_DISMISS_MS}ms` }} />
        </div>
    );
}

export default Toast;
